<template>
    <div class="container">
        <div class="row">
            <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
                <div class="account-box">
                    <div :class="{ loader: !isShowSppiner }" style="position:absolute;background-color:#80808033;top:0;bottom:0;left:0;right:0;z-index:9999;width:100%;height:100%">
                        <img style="position:absolute;top:40%;left:43%;z-index:100" src="/assets/img/loader/loader.svg" />
                    </div>
                    <router-link to="/" class="logo">
                        <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                    </router-link>
                    <div class="account-box-title text-center">کد ارسالی به موبایتان را وارد کنید</div>
                    <div class="account-box-content">
                        <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                            <li v-for="error in errors.all()">{{ error }}</li>
                        </ul>
                        <form @submit.prevent="validateForm" class="form-account">
                            <div class="form-account-row">
                                <!--<label class="input-label"><i class="now-ui-icons ui-1_lock-circle-open"></i></label>-->
                                <input name="sendcode" maxlength="5" v-model="sendCode" data-vv-as="کد تایید" v-validate="{required: true, digits:5 }" class="input-field" type="text" placeholder="-----">
                            </div>
                            <div class="form-account-row form-account-submit">
                                <div class="parent-btn">
                                    <button type="submit" class="dk-btn dk-btn-info">
                                        تایید شماره
                                        <i class="now-ui-icons arrows-1_share-66"></i>
                                    </button>
                                    <div class="mt20 mb50">
                                        <span class="fright fsmini time active" v-if="showCounter">زمان باقیمانده :  ( <span v-if="showCounter">{{ time }} </span>)</span>   <span class="resendCode" v-if="!showCounter" @click="ReSendCode">ارسال مجدد کد تأیید</span>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="account-box-footer">
                        <div>
                            <router-link class="btn-redirect-page" to="/">بازگشت به صفحه اصلی</router-link>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                sendCode: '',
                time: '00:00',
                showCounter: true,
                isShowSppiner: false
            }
        },
        computed: {
            confirmationCodeHashId: function () {
                return this.$store.getters.readConfirm.confirmationCodeHashId;
            },
            timeRemaningForExpire: function () {
                return this.$store.getters.readConfirm.timeRemaningForExpire;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeMount: function () {
            this.initialCounter(this.timeRemaningForExpire);
            createPageTitle('تأیید شماره موبایل');
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isShowSppiner = true;
                        httpPromise(this, '/v1/Identity/ForgetPassword/Confirm/', 'post', JSON.stringify({ ConfirmationCodeHashId: this.confirmationCodeHashId, SendCode: this.sendCode }),
                            response => {
                                toastr.success(response.data.Message);
                                this.isShowSppiner = false;
                                this.$emit('redirectToChangePassword', '');
                            },
                            response => {
                                toastr.error(response.data.Message);
                                this.isShowSppiner = false;
                            });
                    }
                });
            },
            initialCounter(timeToExpire) {
                var intervalFn = setInterval(function () {
                    this.time = (Math.floor(timeToExpire / 60) < 10 ? "0" + Math.floor(timeToExpire / 60) : Math.floor(timeToExpire / 60)) + ":" + (timeToExpire % 60 < 10 ? "0" + timeToExpire % 60 : timeToExpire % 60);
                    timeToExpire--;
                    if (timeToExpire < 0) {
                        clearInterval(intervalFn);
                        this.showCounter = false;
                    }
                }.bind(this), 1000);
            }, 
            ReSendCode() {
                httpPromise(this, '/v1/Identity/UserRegister/ReSendCode', 'post', JSON.stringify({ ConfirmationCodeHashId: this.confirmationCodeHashId }),
                    response => {
                        this.showCounter = true;
                        this.initialCounter(response.data.Value); 
                    }, 
                    response => { }
                );
            },
        }
    }
</script>

<style scoped>
      .account-box {
        margin: 120px auto;
    }
    .input-field::placeholder {
        color: #c8c8c8;
        font-size: 81px;
        text-align: center;
        padding-right: 0px;
        letter-spacing: 10px;
        position: absolute;
        right: 37px !important;
    }

    .input-field {
        padding: 11px 0px 11px 11px !important;
        text-align: center !important;
        letter-spacing: 10px;
        font-size: 21px;
    }

    .mt20 {
        margin-top: 20px;
    }

    .mb30 {
        margin-bottom: 30px;
    }

    .time.active {
        color: #333;
       

    }
    .resendCode {
        color: #333;
        cursor: pointer;
    }
    .btn-redirect-page {
        background-color: #fff8f8;
        border-bottom: 1px dashed #1ca2bd;
        margin-top: 10px;
        display: inline-block;
        border-radius: 5px;
        color: #1ca2bd;
        transition: all .3s;
        padding: 6px;
        font-size: 12px;
    }

    .account-box-footer {
        border-top: 1px solid rgba(0, 190, 214, .13);
        padding: 0 0 15px 0;
    }

    .btn-redirect-page:hover {
        transition: all .3s;
        color: #1ca2bd;
    }
</style>